// React and Icons
import React from 'react'
import { IoArrowBackOutline } from 'react-icons/io5'
import { MdOutlineAddCircleOutline } from 'react-icons/md'

// Components
import Materials from '../../components/Material'
import LinkButton from '../../components/Custom/Buttons/LinkButton'
import PageHeader from '../../components/Custom/PageHeader/PageHeader'

// Hooks and Utils
import useGoBack from '../../hooks/useGoBack'
import useUserStore from '../../utils/state/useUserStore'

const Material = () => {
  const GoBack = useGoBack()
  const userPermissions = useUserStore((state) => state.user) || []

  return (
    <div>
      <PageHeader>
        <div className='flex gap-2 items-center justify-between w-full'>
          <div className='flex gap-2 items-center font-medium'>
            <h1 className='text-2xl'>Material</h1>
          </div>
          {userPermissions?.includes('material:create') ? (
            <LinkButton
              icon={<MdOutlineAddCircleOutline className='text-xl' />}
              to={'/material/add'}
              label={'Add Material'}
            />
          ) : null}
        </div>
      </PageHeader>
      <Materials userPermissions={userPermissions} />
    </div>
  )
}

export default Material
